
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { OperacaoGarantida } from 'src/app/model/operacao-garantida.model';
import { OperacaoCreditoLivre } from 'src/app/model/operacao-credito-livre.model';
import { OperacaoRepasseBndes } from 'src/app/model/operacao-repasse-bndes.model';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { CalculoEcg, CalculoEcgRetorno } from 'src/app/model/calculo-ecg.model';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { CalculoSaldoDevedorRetorno } from 'src/app/model/calculo-saldo-devedor';

export const LIMITE_OPERACOES_EXPORTADAS = 5000;

@Injectable({
  providedIn: 'root'
})
export class OperacaoGarantidaService extends FgiBackEndService<OperacaoGarantida> {

  // @Override
  getNewEntity(): OperacaoGarantida {
    throw new Error('OperacaoGarantida eh classe abstrata. Usar servicos especificos (Repasse ou Credito Livre) para criacao.');
  }

  // @Override
  convertToType(value): OperacaoGarantida {
    if (value && value.codigoTipoOperacao == "R") {
      return <OperacaoGarantida> new OperacaoRepasseBndes().extend(value);
    }
    else {
      return <OperacaoGarantida> new OperacaoCreditoLivre().extend(value);
    }
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/operacoes';
  }

  // nao tem no BaseEntityService pra fazer override
  calcularEcg(calculoEcg: CalculoEcg): Observable<CalculoEcgRetorno> {
    return this.http.post(`${this.BASE_URL}/calculo-ecg`, calculoEcg, blockUi()).pipe(
      catchError((e) => this.handleError(e))) as Observable<CalculoEcgRetorno>;
  } 

  // nao tem no BaseEntityService pra fazer override
  calcularSaldoDevedor(idOperacaoCredito: number, dataCalculo: string): Observable<CalculoSaldoDevedorRetorno> {
    return this.http.get(`${this.BASE_URL}/calculo-saldo-devedor/${idOperacaoCredito}/${dataCalculo}`, blockUi()).pipe(
      catchError((e) => this.handleError(e))) as Observable<CalculoSaldoDevedorRetorno>;
  } 

  // nao tem no BaseEntityService pra fazer override
  getOperacoes(params?: any, options?: any): Observable<ResultadoPaginado<OperacaoGarantida>> {
    return this.http.get(`${this.BASE_URL}`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<OperacaoGarantida>>;
  }

  // @override
  save(operacao: OperacaoGarantida, options?: any): Observable<OperacaoGarantida> {
    throw new Error('Save individual nao suportado de operacao garantida nao suportado.');
  }

  // @override
  update(regra: OperacaoGarantida, options?: any): Observable<OperacaoGarantida> {
    throw new Error('Update de operacao garantida nao suportado. Atualizacoes em dados de '
      + 'operacoes devem ser feitas via retificacoes ou aditivos');
  }

  informarLiquidacaoOperacao(idOperacao: number) : Observable<string> {
    return this.http.post(`${this.BASE_URL}/informar-liquidacao/${idOperacao}`, blockUi()).pipe(
      catchError((e) => this.handleError(e))) as Observable<string>;
  }

}
